import { render, staticRenderFns } from "./ModalAddDay.vue?vue&type=template&id=145f707d&"
import script from "./ModalAddDay.vue?vue&type=script&lang=js&"
export * from "./ModalAddDay.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddDay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports